import {
  fetchCompanyStatsDigitalRevenueTrends,
  fetchCompanyStatsDigitalRevenueGames,
  fetchCompanyStatsDigitalRevenueMarkets,
} from '@/pages/intelligence/services/companies';
import { getComputeTypeStreaming } from '@/pages/intelligence/utils/topchartsUtils';

export async function getDigitalRevenueTrendData(params, tabId) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const trendsRes = await fetchCompanyStatsDigitalRevenueTrends({
      ...params,
      order_metric: 'date',
    });
    const lineData = trendsRes?.data?.trend || [];

    let revenueTrendCoundMsg = getComputeTypeStreaming(
      trendsRes?.data?.avg_by_line,
      trendsRes?.data?.total_by_line,
      trendsRes?.data?.max_by_line,
    );
    let unitsTrendCoundMsg = getComputeTypeStreaming(
      trendsRes?.data?.avg_by_line,
      trendsRes?.data?.total_units_by_line,
      trendsRes?.data?.max_by_line,
    );

    const tableData = trendsRes?.data?.table || [];
    const trendTotal = tableData?.length;

    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !trendTotal,
      },
      lineData: lineData || [],
      tableData: tableData,
      total: trendTotal,
      startDate: trendsRes?.req?.start_date || '',
      endDate: trendsRes?.req?.end_date || '',
      trendCoundMsg: {
        digitalRevenue: revenueTrendCoundMsg,
        units: unitsTrendCoundMsg,
      },
    };
  } catch (err) {
    console.error(err);
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      total: 0,
      startDate: '',
      endDate: '',
      trendCoundMsg: {},
    };
  }
}

export async function getDigitalRevenueGamesData(params, tabId) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const gamesRes = await fetchCompanyStatsDigitalRevenueGames(params);
    //1 aggregated为可视化柱状和饼， 需要过滤掉allgame
    //2 表格数据排序和分页需要重新调接口，但可视化不需要更新
    //3 请求折线图接口，需要给top5游戏数据，页面改变筛选器才重新请求

    const tableData = gamesRes?.data?.game_share_data_list || [];
    const fixedData = gamesRes?.data?.game_share_data_total || [];
    tableData.unshift(fixedData);
    const gameTotal = gamesRes?.data?.total_count || 0;
    const lineData = gamesRes?.data?.game_share_metric_time_line || [];
    const barOrPieData = gamesRes?.data?.game_share_pie_chart || [];

    return {
      cardData: {
        loading: false,
        error: false,
        isNoData: !gameTotal,
      },
      lineData: lineData || [],
      tableData: tableData,
      barOrPieData: barOrPieData,
      total: gameTotal,
    };
  } catch (err) {
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      barOrPieData: [],
      total: 0,
    };
  }
}

export async function getDigitalRevenueCountryData(params, tabId) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const countryRes = await fetchCompanyStatsDigitalRevenueMarkets(params);
    const tableData = countryRes?.data?.game_market_data || [];
    const allGamesObject = tableData?.find((item) =>
      ['total', 'all_markets'].includes(item?.market),
    );
    const newTableList = tableData.filter(
      (item) => !['total', 'all_markets'].includes(item?.market),
    );
    if (allGamesObject) {
      newTableList.unshift({
        ...(allGamesObject || {}),
        market: 'total',
        name: 'total',
      });
    }

    const gameTotal = countryRes?.data?.total || 0;
    const lineData = countryRes?.data?.metric_time_line || [];
    const barOrPieData = countryRes?.data?.aggregated || [];
    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !gameTotal,
      },
      lineData: lineData || [],
      tableData: newTableList,
      barOrPieData: barOrPieData,
      total: gameTotal,
    };
  } catch (err) {
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      barOrPieData: [],
      total: 0,
    };
  }
}

export const getMetricValueOfCvmTrendCountry = (
  cvm: any,
  metricKey: string,
) => {
  if (!cvm || !metricKey) {
    return {};
  }
  const metric = cvm?.[metricKey] || [];
  if (!metric) {
    return {};
  }
  if (metricKey?.indexOf('OfCompany') > -1) {
    return { ...metric, value: metric?.ratio, growth_ratio: metric?.ratio };
  }
  return { ...metric, value: metric?.this, growth_ratio: metric?.ratio };
};

export const getMetricValueOfCvmGame = (cvm: any, metricKey: string) => {
  if (!cvm || !metricKey) {
    return {};
  }
  const metrics = cvm?.metric_info || [];
  const metric = metrics.find((item: any) => {
    return item?.metric === metricKey;
  });
  if (metricKey?.indexOf('OfCompany') > -1) {
    return { ...metric, value: metric?.dod_int, growth_ratio: metric?.dod_int };
  }
  return { ...metric, value: metric?.value, growth_ratio: metric?.dod_int };
};
